var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.element.options !== null && _vm.element.options.attrs !== null
    ? _c(
        "el-button",
        {
          class:
            "de-search-button" +
            (_vm.useDarkClass ? " dark-search-button" : ""),
          attrs: {
            type: _vm.element.options.attrs.type,
            round: _vm.element.options.attrs.round,
            plain: _vm.element.options.attrs.plain,
            size: _vm.size,
          },
          on: { click: _vm.triggerSearch },
        },
        [_vm._v("\n  " + _vm._s(_vm.element.options.value) + "\n")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }